<template>
  <div class="ecosystem-webhook-settings">
    <b-form-checkbox :checked="settings.webhook_enabled" @change="update('webhook_enabled', $event)">
      <translate>Webhooks enabled</translate>
    </b-form-checkbox>
    <b-form-checkbox :checked="settings.shipping_webhooks_enabled" class="mb-2" @change="update('shipping_webhooks_enabled', $event)">
      <translate>Send shipping webhooks</translate>
    </b-form-checkbox>
    <b-form-row>
      <b-col md="3">
        <b-form-group :label="$gettext('Method')" :label-for="id + '-method'">
          <b-form-select :id="id + '-method'" :value="settings.webhook_method" :options="methods" @change="update('webhook_method', $event)">
            <template #first>
              <option :value="null" v-translate>Select</option>
            </template>
          </b-form-select>
        </b-form-group>
      </b-col>
      <b-col md="9">
        <b-form-group :label="$gettext('URL')" :label-for="id + '-url'" :description="$gettext('Complete and valid URL')">
          <b-form-input :id="id + '-url'" :value="settings.webhook_url" type="url" trim @input="update('webhook_url', $event || null)" />
        </b-form-group>
      </b-col>
    </b-form-row>
    <b-form-group :label="$gettext('Headers')" :description="$gettext('Array of objects (one Key/Value pair per object)')">
      <v-jsoneditor
        :value="settings.webhook_headers"
        :height="'200px'"
        :options="{ modes: ['tree', 'view', 'form', 'code', 'text', 'preview'], mode: 'code' }"
        @input="update('webhook_headers', $event)"
      />
    </b-form-group>
  </div>
</template>

<script>
import VJsoneditor from 'v-jsoneditor/src/index'

// Methods accepted by the backend for application webhooks; ecosystem webhooks share the sender
const METHODS = ['POST', 'GET', 'PUT', 'PATCH']

// Subform for an ecosystem's `webhook_settings` (MOOV-5543), used through the engine's componentEdit.
// Keys it doesn't know are kept as they are, since the backend replaces the whole object on PATCH.
export default {
  name: 'EcosystemWebhookSettings',
  components: {
    VJsoneditor
  },
  props: {
    value: {
      type: Object,
      default: null
    },
    id: {
      type: String,
      default: 'webhook-settings'
    }
  },
  data() {
    return {
      methods: METHODS
    }
  },
  computed: {
    // Backend defaults: webhook_enabled is true when missing, shipping_webhooks_enabled false
    settings() {
      const value = this.value || {}
      return {
        ...value,
        webhook_enabled: value.webhook_enabled !== undefined ? !!value.webhook_enabled : true,
        shipping_webhooks_enabled: !!value.shipping_webhooks_enabled,
        webhook_method: value.webhook_method || null,
        webhook_url: value.webhook_url || null,
        webhook_headers: value.webhook_headers || []
      }
    }
  },
  methods: {
    update(key, val) {
      this.$emit('input', { ...this.settings, [key]: val })
    }
  }
}
</script>
